import 'bootstrap/dist/js/bootstrap.bundle';
import { createPopper } from '@popperjs/core';
window.$ = require('jquery');
require('aos/dist/aos.js');

// Font Awesome
import fontawesome from '@fortawesome/fontawesome-pro/js/fontawesome'
import solid from '@fortawesome/fontawesome-pro/js/solid'
import regular from '@fortawesome/fontawesome-pro/js/regular'
import light from '@fortawesome/fontawesome-pro/js/light'
import thin from '@fortawesome/fontawesome-pro/js/thin'
import brands from '@fortawesome/fontawesome-pro/js/brands'
import Alpine from 'alpinejs'
 
window.Alpine = Alpine
 
Alpine.start()

// Animate.css on click
$(document).ready(function() {

	animationClick('.fadeOutDown1','fadeOutDown');
	      
	function animationClick(element, animation){
	  element = $(element);
	  element.click(
	    function() {
	      element.addClass('animated ' + animation);
	      //wait for animation to finish before removing classes
	      window.setTimeout( function(){
	          element.removeClass('animated ' + animation);
	      }, 2000);
	    }
	  );
	};     
       
});

// Look for .hamburger
$(function(){
  if($('body').is('.main')){
    var hamburger = document.querySelector(".hamburger");
    // On click
    hamburger.addEventListener("click", function() {
      // Toggle class "is-active"
      hamburger.classList.toggle("is-active");
      // Do something else, like open/close menu
    });
  }
});


// AOS
window.aos = require('aos');
aos.init({
	startEvent: 'DOMContentLoaded',
	easing: 'ease-in',
  delay: 500,
	once: false,
	mirror: true
});

// Smooth Scroll
// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  // On-page links
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    && 
    location.hostname == this.hostname
  ) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000, function() {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) { // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        };
      });
    }
  }
});

// Coded by Unlimited Studio – https://unlimited.studio